var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetworking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0003 11.9333C29.9003 11.9166 29.7836 11.9166 29.6836 11.9333C27.3836 11.8499 25.5503 9.96659 25.5503 7.63325C25.5503 5.24992 27.467 3.33325 29.8503 3.33325C32.2336 3.33325 34.1503 5.26659 34.1503 7.63325C34.1336 9.96659 32.3003 11.8499 30.0003 11.9333Z",
    stroke: "#D12E29",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2834 24.0666C30.5667 24.4499 33.0834 24.0499 34.8501 22.8666C37.2001 21.2999 37.2001 18.7333 34.8501 17.1666C33.0667 15.9833 30.5167 15.5833 28.2334 15.9833",
    stroke: "#D12E29",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94981 11.933C10.0498 11.9163 10.1665 11.9163 10.2665 11.933C12.5665 11.8497 14.3998 9.96634 14.3998 7.63301C14.3998 5.24968 12.4831 3.33301 10.0998 3.33301C7.71647 3.33301 5.7998 5.26634 5.7998 7.63301C5.81647 9.96634 7.64981 11.8497 9.94981 11.933Z",
    stroke: "#D12E29",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 24.0666C9.38323 24.4499 6.86657 24.0499 5.0999 22.8666C2.7499 21.2999 2.7499 18.7333 5.0999 17.1666C6.88324 15.9833 9.43323 15.5833 11.7166 15.9833",
    stroke: "#D12E29",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 24.3837C19.9003 24.367 19.7836 24.367 19.6836 24.3837C17.3836 24.3004 15.5503 22.417 15.5503 20.0837C15.5503 17.7004 17.467 15.7837 19.8503 15.7837C22.2336 15.7837 24.1503 17.717 24.1503 20.0837C24.1336 22.417 22.3003 24.317 20.0003 24.3837Z",
    stroke: "#D12E29",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1502 29.6338C12.8002 31.2005 12.8002 33.7672 15.1502 35.3338C17.8169 37.1172 22.1835 37.1172 24.8502 35.3338C27.2002 33.7672 27.2002 31.2005 24.8502 29.6338C22.2002 27.8672 17.8169 27.8672 15.1502 29.6338Z",
    stroke: "#D12E29",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworking);
export default __webpack_public_path__ + "static/media/networking.efafba1cd252145e2c78d61070e6e21e.svg";
export { ForwardRef as ReactComponent };